import { useContext } from "react";
import { ColorProvider } from "~components/common/Layout";

export const Vegan = () => {
  const { color, productBackground } = useContext(ColorProvider);
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="0.5" width="59" height="59" rx="29.5" fill="white" />
      <rect x="1" y="0.5" width="59" height="59" rx="29.5" stroke="#E2DFDF" />
      <circle
        cx="19.7285"
        cy="22.2617"
        r="5.77148"
        fill={productBackground || color}
      />
      <path
        d="M35 40.9978V35.4977C35 34.6693 35.6716 33.9977 36.5001 33.9977C37.3285 33.9977 38 34.6693 38 35.4977V40.9978"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M35 38.6675H38"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.5 40.9978V33.9977L45.5001 40.9978V33.9977"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.5 40.9978H22.5V33.9977H25.5"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.5 37.5005H22.5"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5 33.9977L17.5001 40.9978L19.5001 33.9977"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.5 35.7477V35.7471C31.5 34.7809 30.7168 33.9977 29.7507 33.9977H29.75C28.7835 33.9977 28 34.7812 28 35.7477V39.2477C28 40.2143 28.7835 40.9978 29.75 40.9978C30.7165 40.9978 31.5 40.2143 31.5 39.2477V38.4978H30.625"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5 14.9994C25.5712 14.9994 30.5001 19.9284 30.5001 25.9995C24.429 25.9995 19.5 21.0706 19.5 14.9994Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.5001 14.9994C35.429 14.9994 30.5 19.9284 30.5 25.9995C36.5712 25.9995 41.5001 21.0706 41.5001 14.9994Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5 45.0005H45.5004"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5 30.0005H45.5004"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
